import React from 'react'
import Sidebar from '../components/Sidebar'
import ExploreFeed from '../sections/ExploreFeed'

const Explore = () => {
    return (
        <div className='home'>
            <Sidebar />
            <div className="home__content-container">
                <ExploreFeed />
            </div>
        </div>
    )
}

export default Explore